const defaultNavigation = {
  username: '',
  links: [],
  labels: {},
  'home-url': '',
  'logout-url': '',
}
const navigationData = {
  ...defaultNavigation,
  ...window.navigation,
}
export default navigationData
